import { useRef } from 'react';
import appConstants from '../../../../constants';
import { KEYS } from '../../../../l18n/constants';
import computeClassName from '../../../../utils/computeClassName';
import handleClick from '../../../../utils/handleClick';
import navigateToURL from '../../../../utils/navigateToURL';
import { useL18nContext } from '../../ContextProvider/L18n';
import { usePartnerSearchContext } from '../../ContextProvider/Partner/Search';
import CCButtonPrimary from '../../../libs/CiscoCore/Button/Primary';
import CCIconClose20x20 from '../../../libs/CiscoCore/Icon/Close/20x20';
import useClickOutside from '../../../../hooks/ui/useClickOutside';

const constants = Object.freeze({
  CLASSNAME_BASE: 'bg-cc-primary shadow-cc-menu px-6 flex flex-col items-center justify-between w-full sm:w-72 h-32'
});

const propsDefaults = Object.freeze({
  isUserLoggedIn: false,
  userId: '',
  toggleOffUserMenuFn: null,
});

export default function UserMenu(
  {
    isUserLoggedIn = propsDefaults.isUserLoggedIn,
    userId = propsDefaults.userId,
    toggleOffUserMenuFn = propsDefaults.toggleOffUserMenuFn,
    className = ''
  }
) {
  const componentRef = useRef();
  useClickOutside(componentRef, toggleOffUserMenuFn);

  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { getTranslationFor } = useL18nContext();
  const translatedLabelTitleButtonClose = getTranslationFor(KEYS.L18N_KEY_LABEL_CLOSE);
  const translatedLabelTitleButtonLogInLogOut = getTranslationFor(isUserLoggedIn?KEYS.L18N_KEY_LABEL_LOG_OUT:KEYS.L18N_KEY_LABEL_LOG_IN);
  const translatedLabelNoAccount = getTranslationFor(KEYS.L18N_KEY_LABEL_DONT_HAVE_AN_ACCOUNT);
  const translatedLabelSignUp = getTranslationFor(KEYS.L18N_KEY_LABEL_SIGN_UP);
  const closeButtonClickFn = handleClick(toggleOffUserMenuFn);

  const { persistAppState } = usePartnerSearchContext();

  function login() {
    persistAppState();
    navigateToURL(appConstants.SSO_LOGIN_URL);
  }

  function logout() {
    navigateToURL(appConstants.SSO_LOGOUT_URL);
  }

  const buttonLogInLogOutClickFn = isUserLoggedIn ? handleClick(logout):handleClick(login);

  return (
    <div className={computedClassName} ref={componentRef}>
      <button className="appearance-none absolute top-cc-3.75 right-cc-3.75 z-10"
              title={translatedLabelTitleButtonClose}
              onClick={closeButtonClickFn}>
        <CCIconClose20x20 aria-hidden="true" className="w-5 h-5"/>
      </button>
      {
        isUserLoggedIn &&
        <>
          <p className="text-cc-secondary-contrast text-cc-body-small text-center mt-6">{userId}</p>
          <CCButtonPrimary className="flex-shrink-0 w-40 mb-6" title={translatedLabelTitleButtonLogInLogOut} size="small" clickFn={buttonLogInLogOutClickFn}>{translatedLabelTitleButtonLogInLogOut}</CCButtonPrimary>
        </>
      }
      {
        !isUserLoggedIn &&
        <>
          <CCButtonPrimary className="flex-shrink-0 w-40 mt-8 mb-2" title={translatedLabelTitleButtonLogInLogOut} size="small" clickFn={buttonLogInLogOutClickFn}>{translatedLabelTitleButtonLogInLogOut}</CCButtonPrimary>
          <p className="text-cc-primary-contrast text-cc-body-small text-center mb-6">{translatedLabelNoAccount} <a href={appConstants.CDC_LINKS.signUp} target="_self" className="text-cc-accent no-underline font-semibold">{translatedLabelSignUp}</a></p>
        </>
      }
    </div>
  );
}
